import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { Button, DateDisplay } from "../../../components";
import { FormCheck } from "../../../components/forms";
import { AttachmentsToggle, ThemedParagraph, ThemedSpan } from "../../../components/utilities";
import MessageBox from "./MessageBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import EditMessageModal from "../../editmessagemodal";
import MessageActionMenuDropdown from "./MessageActionMenuDropdown";
import { useMessageThreadContext } from "../hooks/MessageThreadContext";

const MessageHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-column-gap: 20px;
`;

const ReadOnlyMessage = React.forwardRef(({
    message,
    onDone,
    onReply,
    style
}, ref) => {

    const [showEditModal, setShowEditModal] = useState(false);

    const { userId } = useMessageThreadContext();

    const {
        sentOnDate,
        message: messageText,
        recipients,
        senderName,
        doneByName,
        isDone,
        doneDate,
        threadSubject,
        messagePriority,
        isActionRequired,
        attachments,
        senderId
    } = message;

    const recipientsString = useMemo(() => recipients.map(x => x.displayName).join(", "), [recipients]);

    const replyButtonText = useMemo(() => recipients.length > 1 ? "Reply All" : "Reply", [recipients]);

    return <React.Fragment>
        <MessageBox ref={ref} className="mb-3 rounded" style={style}>
            <MessageHeader className="align-items-center mb-1">
                <div className="d-flex">
                    <b>
                        <ThemedSpan>
                            from {senderName} to {recipientsString} at <DateDisplay format="HH:mm DD/MM/YY">{sentOnDate}</DateDisplay>
                        </ThemedSpan>
                    </b>
                    {messagePriority === 30 && <div className="ms-2">
                        <OverlayTrigger overlay={
                            <Tooltip>High Priority</Tooltip>
                        }>
                            <FontAwesomeIcon className="text-danger" icon={"exclamation-circle"} size={"lg"} />
                        </OverlayTrigger>
                    </div>}
                </div>
                <div>
                    <ThemedSpan variant="muted">{threadSubject}</ThemedSpan>
                </div>

                <Button
                    onClick={onReply}
                    variant="success"
                    className="border-dark"
                >
                    {replyButtonText}
                </Button>
            </MessageHeader>
            <div className="row">
                <ThemedParagraph
                    variant="primary"
                >
                    {messageText}
                </ThemedParagraph>
            </div>
            <div className="d-flex mt-auto align-items-end">
                {isActionRequired && <React.Fragment>
                    <FormCheck
                        onChange={() => onDone(!isDone)}
                        label={"Done"}
                        isChecked={isDone}
                    />
                    {
                        doneByName && doneDate && <ThemedSpan className="ms-2">
                            ({doneByName} at <DateDisplay format="HH:mm DD/MM/YYYY">{doneDate}</DateDisplay>)
                        </ThemedSpan>

                    }
                </React.Fragment>}
                <div className="d-flex ms-auto">
                    {Array.isArray(attachments) && attachments.length > 0 && <div className="me-2">
                        <AttachmentsToggle attachments={attachments} />
                    </div>}
                    {senderId === userId && <MessageActionMenuDropdown onEditClick={() => setShowEditModal(true)} />}
                </div>
            </div>

        </MessageBox>
        <EditMessageModal
            data={message}
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            queryParams={{ userId }}
        />
    </React.Fragment>;
});

export default ReadOnlyMessage;